import React from 'react';
import { Routes, Route, Navigate, useOutletContext } from 'react-router-dom';
import EmailReviewQueue from './EmailReviewQueue';
import EmailHistory from './EmailHistory';
import EmailAnalytics from './EmailAnalytics';
import { ManualEmailDraft } from '../../components/EmailCampaigns/ManualEmailDraft';

const EmailCampaignRoutes: React.FC = () => {
  const { emailFollowUpEnabled } = useOutletContext<{ emailFollowUpEnabled: boolean | null }>();
  
  // If email campaigns are not enabled, redirect all sub-routes to the base path
  if (emailFollowUpEnabled === false) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/follow-up-messages" replace />} />
      </Routes>
    );
  }
  
  // If we're still loading the enabled state, don't render routes yet
  if (emailFollowUpEnabled === null) {
    return null;
  }
  
  // Email campaigns are enabled - render all routes normally
  return (
    <Routes>
      <Route index element={<Navigate to="review" />} />
      <Route path="review" element={<EmailReviewQueue />} />
      <Route path="history" element={<EmailHistory />} />
      <Route path="analytics" element={<EmailAnalytics />} />
      <Route path="manual-draft" element={<ManualEmailDraft />} />
      {/* Settings route removed - now in account-specific email settings */}
      {/* Catch-all for invalid paths - redirect to review */}
      <Route path="*" element={<Navigate to="/follow-up-messages/review" />} />
    </Routes>
  );
};

export default EmailCampaignRoutes;